import { IssuesColumnsIdEnum } from "pages/Corporate/RCA/RCAIssues/useRCAIssuesColumns/useRCAIssuesColumnsInterfaces";
import { IIssuesTableOperationFilters } from "./IIssueEntityInterfaces";

/** Order value for Hasura order_by (asc | desc) */
export type OrderDirection = "asc" | "desc";

/** Shape of the order_by variable for getIssues queries */
export interface IssuesOrderByVariable {
    sequence_id?: OrderDirection;
    description?: OrderDirection;
    due_date?: OrderDirection;
    status?: { order: OrderDirection };
    owner?: { user_id: OrderDirection };
}

/**
 * Builds the order_by object for issue list queries from table operation filters.
 * Used by GetIssues and GetUserIssues to avoid duplicating the column-to-field mapping.
 */
export function getIssuesOrderBy(
    tableOperationFilters: IIssuesTableOperationFilters,
): IssuesOrderByVariable {
    const order = tableOperationFilters.order as OrderDirection;
    return {
        ...(tableOperationFilters.orderBy === IssuesColumnsIdEnum.NUMBER && {
            sequence_id: order,
        }),
        ...(tableOperationFilters.orderBy === IssuesColumnsIdEnum.DESCRIPTION && {
            description: order,
        }),
        ...(tableOperationFilters.orderBy === IssuesColumnsIdEnum.DUE_DATE && {
            due_date: order,
        }),
        ...(tableOperationFilters.orderBy === IssuesColumnsIdEnum.STATUS && {
            status: { order },
        }),
        ...(tableOperationFilters.orderBy === IssuesColumnsIdEnum.OWNER && {
            owner: { user_id: order },
        }),
    };
}
